const CHANGE_REDIRECT_FROM_REPORT_FLAG = 'CHANGE_REDIRECT_FROM_REPORT_FLAG';
const API_USER_OVERALL_REPORT_REQUEST = 'API_USER_OVERALL_REPORT_REQUEST';
const API_USER_OVERALL_REPORT_SUCCESS = 'API_USER_OVERALL_REPORT_SUCCESS';
const API_USER_OVERALL_REPORT_FAILURE = 'API_USER_OVERALL_REPORT_FAILURE';

export const changeRedirectFlag = payload => ({
  type: CHANGE_REDIRECT_FROM_REPORT_FLAG,
  payload,
});

export const userOverallReportRequest = () => ({
  type: API_USER_OVERALL_REPORT_REQUEST,
});

export const userOverallReportSuccess = payload => ({
  type: API_USER_OVERALL_REPORT_SUCCESS,
  payload,
});

export const userOverallReportFailure = payload => ({
  type: API_USER_OVERALL_REPORT_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  report: null,
  redirectToLearner: false,
};

export function userOverallReportReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_REDIRECT_FROM_REPORT_FLAG:
      return {
        ...state,
        redirectToLearner: action.payload,
      };
    case API_USER_OVERALL_REPORT_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_USER_OVERALL_REPORT_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        report: action.payload,
      };
    case API_USER_OVERALL_REPORT_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userOverallReport.js